<ng-container *ngIf="state$ | async as state">
    <ng-container [ngSwitch]="state.status">
        <ng-container *ngSwitchDefault>

            <h2 mat-dialog-title class="pv-dialog-title">
                <mat-icon class="material-symbols-outlined">share</mat-icon>
                <span class="pv-dialog-title-text">Share {{ state.data.label }}</span>
                <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
                </button>
            </h2>

            <mat-dialog-content class="pv-dialog-body">
                <form id="report_sharing"
                    [formGroup]="formGroup"
                    (ngSubmit)="attempt()"
                    novalidate
                    autocomplete="no">

                    <div class="field-block">
                        <label class="field-label">Email addresses
                            <span class="field-label-hint">— comma separated</span>
                        </label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input type="text" matInput [formControl]="emailsFormControl" placeholder="eg. john@provar.co.za,sally@gmail.com">
                            <mat-error>Valid email addresses, comma seperated</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="field-block">
                        <label class="field-label">Report access level</label>
                        <div class="chip-row">
                            <button type="button" *ngFor="let access of accessOptions"
                                    class="opt-chip"
                                    [class.active]="accessFormControl.value === access"
                                    [attr.aria-pressed]="accessFormControl.value === access"
                                    (click)="accessFormControl.setValue(access); $event.preventDefault();">
                                <mat-icon class="material-symbols-outlined">{{ access.icon }}</mat-icon>
                                <span>{{ access.label }}</span>
                            </button>
                        </div>
                    </div>
                </form>
            </mat-dialog-content>

            <mat-dialog-actions align="end" class="pv-dialog-footer">
                <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
                <button type="button"
                        mat-stroked-button
                        (click)="copyLink(state.data)"
                        [disabled]="!state.data.shareKey">
                    <mat-icon>link</mat-icon>
                    Copy Link
                </button>
                <button type="button" mat-flat-button color="primary" (click)="attempt()">
                    <mat-icon>check</mat-icon>
                    Apply
                </button>
            </mat-dialog-actions>
        </ng-container>

        <ng-container *ngSwitchCase="'LOADING'">
            <div class="pv-dialog-loading">
                <pv-spinner message="Loading…" fill="white"></pv-spinner>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
